import React, {useState} from "react";
import {getReportContext, ReportContext} from "../../helpers/reportContext";
import {capturePage} from "./screenshot";
import SupportReportDrawer from "./SupportReportDrawer";

type Report = {screenshot?: string; context: ReportContext};

/**
 * „Fehler melden“ von überall: Zuerst wird die Seite aufgenommen, erst dann
 * öffnet sich der Drawer. Der Kontext stammt von vor dem Klick, die Anfragen
 * des Formulars selbst stehen also nicht darin. `drawer` muss der Aufrufer
 * rendern.
 */
export const useSupportReport = () => {
    const [report, setReport] = useState<Report>();
    const [capturing, setCapturing] = useState(false);

    const startReport = async () => {
        const context = getReportContext();

        setCapturing(true);
        const screenshot = await capturePage();

        setCapturing(false);
        setReport({screenshot, context});
    };

    const drawer = report === undefined ? null : <SupportReportDrawer screenshot={report.screenshot} context={report.context} onClose={() => setReport(undefined)} />;

    return {startReport: () => void startReport(), capturing, drawer};
};
